module.exports = __webpack_public_path__ + "static/media/send.afeff6f3.svg";